// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.9141 22H8.08594L12 18.0859L15.9141 22Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 20H16.7422L12 15.2578L7.25781 20H1.00098L1 3H23V20Z"}}]};

const ModePreviewFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'mode-preview-filled',
    ref,
    icon: element,
  },
));

ModePreviewFilledIcon.displayName = 'ModePreviewFilledIcon';

export default ModePreviewFilledIcon;
